import React, { useState, useEffect } from "react";
import Api from "../../../services/api";
import "../../../assets/css/app/monetization.css";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import PaginationComponent from "../../../components/pagination";
import FilterCampaignCenter from "../../../components/filterCampaignCenter";
import ColorCell from "../../../components/colorCell";

import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { END_DATE, networkIcons, START_DATE } from "../../../utility";
import NoDataComponent from "../../../components/noData";
import { CIcon } from "@coreui/icons-react";
import * as icon from "@coreui/icons";
import TableContainer from "../../../components/TableContainer";
import { DownloadOutlined, FullscreenOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Tooltip, Drawer, Spin } from "antd";

const ItemTypes = {
  FIELD: "field",
};

const FilterField = ({ field, index, moveField, toggleCheck }) => {
  const ref = React.useRef(null);
  const [, drop] = useDrop({
    accept: ItemTypes.FIELD,
    hover(item) {
      if (!ref.current) return;
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) return;
      moveField(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.FIELD,
    item: { type: ItemTypes.FIELD, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <div
      ref={ref}
      style={{
        opacity: isDragging ? 0.5 : 1,
        padding: "8px",
        background: "#f9f9f9",
        marginBottom: "4px",
        cursor: "move",
        display: "flex",
        alignItems: "center",
        color: field.checked ? "#000" : "#aaa",
      }}
    >
      <input
        type="checkbox"
        checked={field.checked}
        onChange={() => toggleCheck(index)}
        style={{ marginRight: "10px" }}
      />
      {field.label}
    </div>
  );
};

function AppCampaignCenter() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("campaign");

  const [loading, setLoading] = useState(true);

  const [startDateTab1, setStartDateTab1] = useState(
    moment().subtract(START_DATE, "days")
  );
  const [endDateTab1, setEndDateTab1] = useState(
    moment().subtract(END_DATE, "days")
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  const [data, setData] = useState([]);
  const [dataTotal, setDataTotal] = useState([]);

  const { code, os } = useParams();

  const [filterValuesTab1, setFilterValuesTab1] = useState(null);

  const [expandedGroups, setExpandedGroups] = useState({});

  const [showPopup, setShowPopup] = useState(false);
  const [fields, setFields] = useState([
    { key: "media_source", label: "Media source", checked: true },
    { key: "campaign_id", label: "Campaign", checked: true },
    { key: "date", label: "Date", checked: false },
    { key: "ad_set_id", label: "Ad Network", checked: false },
    { key: "ad_group", label: "Ad group", checked: false },
    { key: "country", label: "Country", checked: false },
  ]);

  const [rowGroupSortDirections, setRowGroupSortDirections] = useState({});
  const [pendingRowGroupChanges, setPendingRowGroupChanges] = useState({
    fields: null,
    sortDirections: null
  });
  const [settingsLoaded, setSettingsLoaded] = useState(false);
  const [selectCountry, setSelectCountry] = useState([]);

  const [sortConfig, setSortConfig] = useState({
    field: null,
    direction: null,
  });

  const toggleGroup = (mediaSource) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [mediaSource]: !prev[mediaSource],
    }));
  };

  const renderFilterFieldControls = (field) => {
    return (
      <>
        <div className="condition-group mb-2">
          <select
            className="form-select form-control mb-2"
            value={filters.conditions[field]?.operator1 || "equals"}
            onChange={(e) => updateCondition(field, "operator1", e.target.value)}
          >
            <option value="equals">Equals</option>
            <option value="notEqual">Does not equal</option>
            <option value="greatThan">Greater than</option>
            <option value="greatThanOrEqual">Greater than or equal to</option>
            <option value="lessThan">Less than</option>
            <option value="lessThanOrEqual">Less than or equal to</option>
            <option value="between">Between</option>
            <option value="blank">Blank</option>
            <option value="notBlank">Not blank</option>
          </select>

          {!["blank", "notBlank"].includes(filters.conditions[field]?.operator1 || "equals") && (
            filters.conditions[field]?.operator1 === "between" ? (
              <div>
                <input
                  type="text"
                  className="form-control mb-2"
                  placeholder="From..."
                  value={Array.isArray(filters.conditions[field]?.value1) ? (filters.conditions[field]?.value1?.[0] || "") : (filters.conditions[field]?.value1 || "")}
                  onChange={(e) => {
                    const current = Array.isArray(filters.conditions[field]?.value1) ? filters.conditions[field]?.value1 : ["", ""];
                    updateCondition(field, "value1", [e.target.value, current[1]]);
                  }}
                />
                {Array.isArray(filters.conditions[field]?.value1) && (filters.conditions[field]?.value1?.[0]) && (
                  <input
                    type="text"
                    className="form-control"
                    placeholder="To..."
                    value={filters.conditions[field]?.value1?.[1] || ""}
                    onChange={(e) => {
                      const current = Array.isArray(filters.conditions[field]?.value1) ? filters.conditions[field]?.value1 : ["", ""];
                      updateCondition(field, "value1", [current[0], e.target.value]);
                    }}
                  />
                )}
              </div>
            ) : (
              <input
                type="text"
                className="form-control"
                placeholder="Enter value..."
                value={filters.conditions[field]?.value1 || ""}
                onChange={(e) => updateCondition(field, "value1", e.target.value)}
              />
            )
          )}
        </div>

        {filters.conditions[field]?.value1 && (
          (filters.conditions[field]?.operator1 !== "between") ||
          (Array.isArray(filters.conditions[field]?.value1) && filters.conditions[field]?.value1[0] && filters.conditions[field]?.value1[1])
        ) && (
          <>
            <div className="logic-radio mb-3">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name={`${field}-logic`}
                  checked={!filters.conditions[field]?.logic || filters.conditions[field]?.logic === "AND"}
                  onChange={() => updateCondition(field, "logic", "AND")}
                />
                <label className="form-check-label">AND</label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name={`${field}-logic`}
                  checked={filters.conditions[field]?.logic === "OR"}
                  onChange={() => updateCondition(field, "logic", "OR")}
                />
                <label className="form-check-label">OR</label>
              </div>
            </div>

            <div className="condition-group">
              <select
                className="form-select form-control mb-2"
                value={filters.conditions[field]?.operator2 || "equals"}
                onChange={(e) => updateCondition(field, "operator2", e.target.value)}
              >
                <option value="equals">Equals</option>
                <option value="notEqual">Does not equal</option>
                <option value="greatThan">Greater than</option>
                <option value="greatThanOrEqual">Greater than or equal to</option>
                <option value="lessThan">Less than</option>
                <option value="lessThanOrEqual">Less than or equal to</option>
                <option value="between">Between</option>
                <option value="blank">Blank</option>
                <option value="notBlank">Not blank</option>
              </select>

              {!["blank", "notBlank"].includes(filters.conditions[field]?.operator2) && (
                filters.conditions[field]?.operator2 === "between" ? (
                  <div>
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="From..."
                      value={Array.isArray(filters.conditions[field]?.value2) ? (filters.conditions[field]?.value2?.[0] || "") : (filters.conditions[field]?.value2 || "")}
                      onChange={(e) => {
                        const current = Array.isArray(filters.conditions[field]?.value2) ? filters.conditions[field]?.value2 : ["", ""];
                        updateCondition(field, "value2", [e.target.value, current[1]]);
                      }}
                    />
                    {Array.isArray(filters.conditions[field]?.value2) && (filters.conditions[field]?.value2?.[0]) && (
                      <input
                        type="text"
                        className="form-control"
                        placeholder="To..."
                        value={filters.conditions[field]?.value2?.[1] || ""}
                        onChange={(e) => {
                          const current = Array.isArray(filters.conditions[field]?.value2) ? filters.conditions[field]?.value2 : ["", ""];
                          updateCondition(field, "value2", [current[0], e.target.value]);
                        }}
                      />
                    )}
                  </div>
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter value..."
                    value={filters.conditions[field]?.value2 || ""}
                    onChange={(e) => updateCondition(field, "value2", e.target.value)}
                  />
                )
              )}
            </div>
          </>
        )}
      </>
    );
  };

  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [filters, setFilters] = useState({
    searchTerm: "",
    activeField: null,
    conditions: {},
    expandedFields: {},
  });

  const [columnFilterPopup, setColumnFilterPopup] = useState({
    activeColumn: null,
    position: { top: 0, left: 0 },
  });

  const columnPopupRef = React.useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnFilterPopup.activeColumn &&
        columnPopupRef.current &&
        !columnPopupRef.current.contains(event.target)
      ) {
        setColumnFilterPopup({ activeColumn: null, position: { top: 0, left: 0 } });
      }
    };

    const handleEsc = (event) => {
      if (event.key === "Escape" && columnFilterPopup.activeColumn) {
        setColumnFilterPopup({ activeColumn: null, position: { top: 0, left: 0 } });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [columnFilterPopup.activeColumn]);

  const ColumnFilterPopupContent = ({ field, filters, updateCondition, getFieldLabel, onClose }) => {
    const input1Ref = React.useRef(null);
    useEffect(() => {
      if (input1Ref.current) {
        input1Ref.current.focus({ preventScroll: true });
      }
    }, [field, filters.conditions[field]?.operator1]);
    return (
      <div className="p-3" style={{ width: "320px" }}>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <b>{getFieldLabel(field)}</b>
          <button className="btn btn-sm btn-light" onClick={onClose}>×</button>
        </div>
        <div className="field-conditions p-2 bg-light rounded">
          <div className="condition-group mb-2">
            <select
              className="form-select form-control mb-2"
              value={filters.conditions[field]?.operator1 || "equals"}
              onChange={(e) => updateCondition(field, "operator1", e.target.value)}
            >
              <option value="equals">Equals</option>
              <option value="notEqual">Does not equal</option>
              <option value="greatThan">Greater than</option>
              <option value="greatThanOrEqual">Greater than or equal to</option>
              <option value="lessThan">Less than</option>
              <option value="lessThanOrEqual">Less than or equal to</option>
              <option value="between">Between</option>
              <option value="blank">Blank</option>
              <option value="notBlank">Not blank</option>
            </select>

            {!["blank", "notBlank"].includes(filters.conditions[field]?.operator1 || "equals") && (
              filters.conditions[field]?.operator1 === "between" ? (
                <div>
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="From..."
                    ref={input1Ref}
                    autoFocus
                    value={Array.isArray(filters.conditions[field]?.value1) ? (filters.conditions[field]?.value1?.[0] || "") : (filters.conditions[field]?.value1 || "")}
                    onChange={(e) => {
                      const current = Array.isArray(filters.conditions[field]?.value1) ? filters.conditions[field]?.value1 : ["", ""];
                      updateCondition(field, "value1", [e.target.value, current[1]]);
                    }}
                  />
                  {Array.isArray(filters.conditions[field]?.value1) && (filters.conditions[field]?.value1?.[0]) && (
                    <input
                      type="text"
                      className="form-control"
                      placeholder="To..."
                      value={filters.conditions[field]?.value1?.[1] || ""}
                      onChange={(e) => {
                        const current = Array.isArray(filters.conditions[field]?.value1) ? filters.conditions[field]?.value1 : ["", ""];
                        updateCondition(field, "value1", [current[0], e.target.value]);
                      }}
                    />
                  )}
                </div>
              ) : (
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter value..."
                  ref={input1Ref}
                  autoFocus
                  value={filters.conditions[field]?.value1 || ""}
                  onChange={(e) => updateCondition(field, "value1", e.target.value)}
                />
              )
            )}
          </div>

          {filters.conditions[field]?.value1 && (
            (filters.conditions[field]?.operator1 !== "between") ||
            (Array.isArray(filters.conditions[field]?.value1) && filters.conditions[field]?.value1[0] && filters.conditions[field]?.value1[1])
          ) && (
            <>
              <div className="logic-radio mb-3">
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={`${field}-logic`}
                    checked={!filters.conditions[field]?.logic || filters.conditions[field]?.logic === "AND"}
                    onChange={() => updateCondition(field, "logic", "AND")}
                  />
                  <label className="form-check-label">AND</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={`${field}-logic`}
                    checked={filters.conditions[field]?.logic === "OR"}
                    onChange={() => updateCondition(field, "logic", "OR")}
                  />
                  <label className="form-check-label">OR</label>
                </div>
              </div>

              <div className="condition-group">
                <select
                  className="form-select form-control mb-2"
                  value={filters.conditions[field]?.operator2 || "equals"}
                  onChange={(e) => updateCondition(field, "operator2", e.target.value)}
                >
                  <option value="equals">Equals</option>
                  <option value="notEqual">Does not equal</option>
                  <option value="greatThan">Greater than</option>
                  <option value="greatThanOrEqual">Greater than or equal to</option>
                  <option value="lessThan">Less than</option>
                  <option value="lessThanOrEqual">Less than or equal to</option>
                  <option value="between">Between</option>
                  <option value="blank">Blank</option>
                  <option value="notBlank">Not blank</option>
                </select>

                {!["blank", "notBlank"].includes(filters.conditions[field]?.operator2) && (
                  filters.conditions[field]?.operator2 === "between" ? (
                    <div>
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="From..."
                        value={Array.isArray(filters.conditions[field]?.value2) ? (filters.conditions[field]?.value2?.[0] || "") : (filters.conditions[field]?.value2 || "")}
                        onChange={(e) => {
                          const current = Array.isArray(filters.conditions[field]?.value2) ? filters.conditions[field]?.value2 : ["", ""];
                          updateCondition(field, "value2", [e.target.value, current[1]]);
                        }}
                      />
                      {Array.isArray(filters.conditions[field]?.value2) && (filters.conditions[field]?.value2?.[0]) && (
                        <input
                          type="text"
                          className="form-control"
                          placeholder="To..."
                          value={filters.conditions[field]?.value2?.[1] || ""}
                          onChange={(e) => {
                            const current = Array.isArray(filters.conditions[field]?.value2) ? filters.conditions[field]?.value2 : ["", ""];
                            updateCondition(field, "value2", [current[0], e.target.value]);
                          }}
                        />
                      )}
                    </div>
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter value..."
                      value={filters.conditions[field]?.value2 || ""}
                      onChange={(e) => updateCondition(field, "value2", e.target.value)}
                    />
                  )
                )}
              </div>
            </>
          )}
        </div>

        <div className="d-flex justify-content-end mt-3">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => {
              setFilters((prev) => ({
                ...prev,
                conditions: {
                  ...prev.conditions,
                  [field]: undefined,
                },
              }));
              onClose();
            }}
          >
            Clear
          </button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const tabParam = searchParams.get("tab");
    if (tabParam && (tabParam === "campaign" || tabParam === "ad-group")) {
      setActiveTab(tabParam);
    }
  }, []);

  const [filterableColumns] = useState([
    "cost",
    "install_ad_network",
    "install_attributed",
    "ecpi_ad_network",
    "ecpi_attributed",
    "RR_D1",
    "RR_D3",
    "RR_D7",
    "RR_D14",
    "RR_D30",
    "RR_D45",
    "RR_D60",
    "ad_revenue",
    "iap_revenue",
    "ipm",
    "ecpm",
    "cti",
    "count_impression",
    "count_session",
    "count_clicks",
    "ecpc",
    "daily_pu",
    "paid_rate",
    "total_ltv_0",
    "total_ltv_1",
    "total_ltv_3",
    "total_ltv_7",
    "total_ltv_14",
    "total_ltv_30",
    "total_ltv_45",
    "total_ltv_60",
    "ltv_iaa_1",
    "ltv_iaa_3",
    "ltv_iaa_7",
    "ltv_iaa_14",
    "ltv_iaa_30",
    "ltv_iaa_45",
    "ltv_iaa_60",
    "ltv_iap_1",
    "ltv_iap_3",
    "ltv_iap_7",
    "ltv_iap_14",
    "ltv_iap_30",
    "ltv_iap_45",
    "ltv_iap_60",
    "ltv_roas_0",
    "ltv_roas_1",
    "ltv_roas_3",
    "ltv_roas_7",
    "ltv_roas_14",
    "ltv_roas_30",
    "ltv_roas_45",
    "ltv_roas_60",
  ]);

  const fetchDataTab1 = (filters) => {
    setLoading(true);

    const cleanedDimensionFilters = (filters?.dimensionFilters || [])
      .filter((f) => f.key && f.value && f.value.length > 0)
      .map((f) => ({ key: f.key, operator: f.operator, value: f.value }));

    const cleanedMetricFilters = (filters?.metricFilters || []).filter(
      (f) => f.key && (f.min !== "" || f.max !== "")
    );

    const params = {
      code: code,
      os: os,
      from:
        filters?.startDate?.format("YYYY-MM-DD") ||
        startDateTab1.format("YYYY-MM-DD"),
      to:
        filters?.endDate?.format("YYYY-MM-DD") ||
        endDateTab1.format("YYYY-MM-DD"),
      page: currentPage,
    };

    if (filters?.sortDirections && typeof filters.sortDirections === 'object') {
      Object.entries(filters.sortDirections).forEach(([k, v]) => {
        if (v === 'asc' || v === 'desc') {
          params[`sortDirections[${k}]`] = v;
        }
      });
    }

    if (filters?.sortKeys?.length > 0) {
      params.sortKeys = filters.sortKeys;
    }

    if (cleanedDimensionFilters.length > 0 || cleanedMetricFilters.length > 0) {
      params.filters = JSON.stringify({
        dimensionFilters: cleanedDimensionFilters,
        metricFilters: cleanedMetricFilters,
      });
    }

    Api.get(`/api/app/campaign_center`, { params })
      .then((result) => {
        if (result.data.code === 0) {
          setOriginalData(result.data.data);
          setFilteredData(result.data.data);
          setDataTotal(result.data.data_total);
          setCurrentPage(result.data.page);
          setTotalPage(result.data.total_page);
          setFilters({
            searchTerm: "",
            activeField: null,
            conditions: {},
            expandedFields: {},
          });
        } else {
          toast.error("Lỗi lấy dữ liệu!!");
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Đã có lỗi xảy ra khi gọi API!");
      });
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await Api.get(
          `/api/app/dimension_filter?dimension=country`
        );
        if (response?.data?.data) {
          const options = Array.isArray(response.data.data)
            ? response.data.data
            : [];
          setSelectCountry(options);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    if (!settingsLoaded) return;
    const effectiveFilters = filterValuesTab1 || {
      startDate: startDateTab1,
      endDate: endDateTab1,
      dimensionFilters: [],
      metricFilters: [],
      sortKeys: (fields || []).filter((f) => f.checked).map((f) => f.key),
      sortDirections: rowGroupSortDirections || {},
    };
    fetchDataTab1(effectiveFilters);
  }, [code, os, currentPage, settingsLoaded]);

  const handleRunReportTab1 = (filters) => {
    const selectedSortKeys = fields.filter((f) => f.checked).map((f) => f.key);

    const updatedFilters = {
      ...filters,
      sortKeys: selectedSortKeys,
      sortDirections: rowGroupSortDirections,
    };

    setStartDateTab1(filters.startDate);
    setEndDateTab1(filters.endDate);
    setFilterValuesTab1(updatedFilters);
    fetchDataTab1(updatedFilters);
  };

  const handleRowGroupSortChange = (fieldKey, direction) => {
    const next = { ...rowGroupSortDirections, [fieldKey]: direction };
    setRowGroupSortDirections(next);
    setPendingRowGroupChanges(prev => ({
      ...prev,
      sortDirections: next
    }));
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const applyRowGroupChanges = () => {
    const fieldsToUse = pendingRowGroupChanges.fields || fields;
    const sortDirectionsToUse = pendingRowGroupChanges.sortDirections || rowGroupSortDirections;
    
    const selectedSortKeys = fieldsToUse.filter((f) => f.checked).map((f) => f.key);
    
    const updatedFilters = {
      startDate: startDateTab1,
      endDate: endDateTab1,
      dimensionFilters: filterValuesTab1?.dimensionFilters || [],
      metricFilters: filterValuesTab1?.metricFilters || [],
      sortKeys: selectedSortKeys,
      sortDirections: sortDirectionsToUse,
    };
    
    setFilterValuesTab1(updatedFilters);
    fetchDataTab1(updatedFilters);
    
    // Reset pending changes
    setPendingRowGroupChanges({
      fields: null,
      sortDirections: null
    });
  };

  const hasPendingRowGroupChanges = React.useMemo(() => {
    return pendingRowGroupChanges.fields !== null || pendingRowGroupChanges.sortDirections !== null;
  }, [pendingRowGroupChanges]);

  const formatNumber = (num) =>
    num.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

  const togglePopup = () => setShowPopup(!showPopup);

  const toggleCheck = (index) => {
    const newFields = [...fields];
    newFields[index].checked = !newFields[index].checked;
    setFields(newFields);
    setPendingRowGroupChanges(prev => ({
      ...prev,
      fields: newFields
    }));
  };

  const moveField = (fromIndex, toIndex) => {
    const newFields = [...fields];
    const [movedItem] = newFields.splice(fromIndex, 1);
    newFields.splice(toIndex, 0, movedItem);
    setFields(newFields);
    setPendingRowGroupChanges(prev => ({
      ...prev,
      fields: newFields
    }));
  };

  const handleDragEnd = () => {
    const selectedSortKeys = fields.filter((f) => f.checked).map((f) => f.key);

  const updatedFilters = {
    startDate: startDateTab1,
    endDate: endDateTab1,
    dimensionFilters: filterValuesTab1?.dimensionFilters || [],
    metricFilters: filterValuesTab1?.metricFilters || [],
    sortKeys: selectedSortKeys,
  };

  handleRunReportTab1(updatedFilters);

    
  };

  const getGroupName = (item) => {
    if (item?.country) {
      const found = selectCountry.find((c) => c.value === item.country);
      if (found) return found.label;
      return item.country;
    }

    return (
      item.media_source ||
      item.campaign_id ||
      item.date ||
      item.ad_set_id ||
      item.ad_group ||
      "unknown"
    );
  };

  const getImage = (item) => {
    if (item?.media_source && networkIcons[item.media_source]) {
      return (
        <img
          width="20px"
          height="20px"
          src={`/icon/${networkIcons[item.media_source]}`}
          alt={item.media_source}
          style={{ marginRight: "8px", borderRadius: "8px" }}
        />
      );
    }

    return "";
  };

  const toggleSort = (field) => {
    setSortConfig((prev) => {
      if (prev.field === field) {
        const newDirection = prev.direction === "asc" ? "desc" : "asc";
        return { field, direction: newDirection };
      } else {
        return { field, direction: "asc" };
      }
    });
  };

  const sortedData = React.useMemo(() => {
    if (!sortConfig.field) return filteredData;

    const sortField = sortConfig.field;
    const direction = sortConfig.direction === "asc" ? 1 : -1;

    const sortRecursive = (items) => {
      return [...items]
        .sort((a, b) => {
          const aVal = parseFloat(a.totals?.[sortField]) || 0;
          const bVal = parseFloat(b.totals?.[sortField]) || 0;
          return aVal > bVal ? direction : aVal < bVal ? -direction : 0;
        })
        .map((item) => ({
          ...item,
          children: Array.isArray(item.children)
            ? sortRecursive(item.children)
            : [],
        }));
    };

    return sortRecursive(filteredData);
  }, [filteredData, sortConfig]);

  const [maxValues, setMaxValues] = useState({ parent: {}, child: {}, parentMin: {}, childMin: {} });

  useEffect(() => {
    if (!filteredData || !Array.isArray(filteredData)) return;

    const metrics = [
      "cost",
      "install_ad_network",
      "install_attributed",
      "ecpi_ad_network",
      "ecpi_attributed",
      "RR_D1",
      "RR_D3",
      "RR_D7",
      "RR_D14",
      "RR_D30",
      "RR_D45",
      "RR_D60",
      "ad_revenue",
      "iap_revenue",
      "ipm",
      "ecpm",
      "cti",
      "count_impression",
      "count_session",
      "count_clicks",
      "ecpc",
      "daily_pu",
      "paid_rate",
      "total_ltv_0",
      "total_ltv_1",
      "total_ltv_3",
      "total_ltv_7",
      "total_ltv_14",
      "total_ltv_30",
      "total_ltv_45",
      "total_ltv_60",
      "ltv_iaa_1",
      "ltv_iaa_3",
      "ltv_iaa_7",
      "ltv_iaa_14",
      "ltv_iaa_30",
      "ltv_iaa_45",
      "ltv_iaa_60",
      "ltv_iap_1",
      "ltv_iap_3",
      "ltv_iap_7",
      "ltv_iap_14",
      "ltv_iap_30",
      "ltv_iap_45",
      "ltv_iap_60",
      "ltv_roas_0",
      "ltv_roas_1",
      "ltv_roas_3",
      "ltv_roas_7",
      "ltv_roas_14",
      "ltv_roas_30",
      "ltv_roas_45",
      "ltv_roas_60",
    ];
    let maxParent = {};
    let maxChild = {};
    let minParent = {};
    let minChild = {};

    metrics.forEach((metric) => {
      maxParent[metric] = 0;
      maxChild[metric] = 0;
      minParent[metric] = 0;
      minChild[metric] = 0;
    });

    filteredData.forEach((parent) => {
      metrics.forEach((metric) => {
        if (parent?.totals?.[metric] !== undefined) {
          const v = Number(parent.totals[metric]) || 0;
          if (v > maxParent[metric]) maxParent[metric] = v;
          if (v < minParent[metric]) minParent[metric] = v;
        }

        if (Array.isArray(parent.children)) {
          parent.children.forEach((child) => {
            if (child?.totals?.[metric] !== undefined) {
              const v = Number(child.totals[metric]) || 0;
              if (v > maxChild[metric]) maxChild[metric] = v;
              if (v < minChild[metric]) minChild[metric] = v;
            }
          });
        }
      });
    });

    setMaxValues({ parent: maxParent, child: maxChild, parentMin: minParent, childMin: minChild });
  }, [filteredData]);

  const METRIC_FORMATS = {
    cost: {
      suffix: "",
      prefix: "$",
    },
    install_ad_network: {
      suffix: "",
      prefix: "",
    },
    install_attributed: {
      suffix: "",
      prefix: "",
    },
    ecpi_ad_network: {
      suffix: "",
      prefix: "$",
    },
    ecpi_attributed: {
      suffix: "",
      prefix: "$",
    },
    RR_D1: {
      suffix: "%",
      prefix: "",
    },
    RR_D3: {
      suffix: "%",
      prefix: "",
    },
    RR_D7: {
      suffix: "%",
      prefix: "",
    },
    RR_D14: {
      suffix: "%",
      prefix: "",
    },
    RR_D30: {
      suffix: "%",
      prefix: "",
    },
    RR_D45: {
      suffix: "%",
      prefix: "",
    },
    RR_D60: {
      suffix: "%",
      prefix: "",
    },
    ad_revenue: {
      suffix: "",
      prefix: "$",
    },
    iap_revenue: {
      suffix: "",
      prefix: "$",
    },
    ipm: {
      suffix: "",
      prefix: "",
    },
    ecpm: {
      suffix: "",
      prefix: "$",
    },
    cti: {
      suffix: "%",
      prefix: "",
    },
    count_impression: {
      suffix: "",
      prefix: "",
    },
    count_session: {
      suffix: "",
      prefix: "",
    },
    count_clicks: {
      suffix: "",
      prefix: "",
    },
    ecpc: {
      suffix: "",
      prefix: "$",
    },
    daily_pu: {
      suffix: "",
      prefix: "",
    },
    paid_rate: {
      suffix: "%",
      prefix: "",
    },
    total_ltv_0: {
      suffix: "",
      prefix: "$",
    },
    total_ltv_1: {
      suffix: "",
      prefix: "$",
    },
    total_ltv_3: {
      suffix: "",
      prefix: "$",
    },
    total_ltv_7: {
      suffix: "",
      prefix: "$",
    },
    total_ltv_14: {
      suffix: "",
      prefix: "$",
    },
    total_ltv_30: {
      suffix: "",
      prefix: "$",
    },
    total_ltv_45: {
      suffix: "",
      prefix: "$",
    },
    total_ltv_60: {
      suffix: "",
      prefix: "$",
    },
    ltv_iaa_1: {
      suffix: "",
      prefix: "$",
    },
    ltv_iaa_3: {
      suffix: "",
      prefix: "$",
    },
    ltv_iaa_7: {
      suffix: "",
      prefix: "$",
    },
    ltv_iaa_14: {
      suffix: "",
      prefix: "$",
    },
    ltv_iaa_30: {
      suffix: "",
      prefix: "$",
    },
    ltv_iaa_45: {
      suffix: "",
      prefix: "$",
    },
    ltv_iaa_60: {
      suffix: "",
      prefix: "$",
    },
    ltv_iap_1: {
      suffix: "",
      prefix: "$",
    },
    ltv_iap_3: {
      suffix: "",
      prefix: "$",
    },
    ltv_iap_7: {
      suffix: "",
      prefix: "$",
    },
    ltv_iap_14: {
      suffix: "",
      prefix: "$",
    },
    ltv_iap_30: {
      suffix: "",
      prefix: "$",
    },
    ltv_iap_45: {
      suffix: "",
      prefix: "$",
    },
    ltv_iap_60: {
      suffix: "",
      prefix: "$",
    },
    ltv_roas_0: {
      suffix: "%",
      prefix: "",
    },
    ltv_roas_1: {
      suffix: "%",
      prefix: "",
    },
    ltv_roas_3: {
      suffix: "%",
      prefix: "",
    },
    ltv_roas_7: {
      suffix: "%",
      prefix: "",
    },
    ltv_roas_14: {
      suffix: "%",
      prefix: "",
    },
    ltv_roas_30: {
      suffix: "%",
      prefix: "",
    },
    ltv_roas_45: {
      suffix: "%",
      prefix: "",
    },
    ltv_roas_60: {
      suffix: "%",
      prefix: "",
    },
  };

  const POSITIVE_COLORS = {
    cost: { r: 40, g: 164, b: 189 },
    install_ad_network: { r: 40, g: 164, b: 189 },
    install_attributed: { r: 40, g: 164, b: 189 },
    ecpi_ad_network: { r: 40, g: 164, b: 189 },
    ecpi_attributed: { r: 40, g: 164, b: 189 },
    RR_D1: { r: 40, g: 120, b: 189 },
    RR_D3: { r: 40, g: 120, b: 189 },
    RR_D7: { r: 40, g: 120, b: 189 },
    RR_D14: { r: 40, g: 120, b: 189 },
    RR_D30: { r: 40, g: 120, b: 189 },
    RR_D45: { r: 40, g: 120, b: 189 },
    RR_D60: { r: 40, g: 120, b: 189 },
    ad_revenue: { r: 40, g: 189, b: 177 },
    iap_revenue: { r: 40, g: 189, b: 177 },
    ipm: { r: 177, g: 189, b: 40 },
    ecpm: { r: 140, g: 189, b: 40 },
    cti: { r: 189, g: 140, b: 40 },
    count_impression: { r: 37, g: 111, b: 100 },
    count_session: { r: 255, g: 9, b: 255 },
    count_clicks: { r: 40, g: 164, b: 189 },
    ecpc: { r: 50, g: 192, b: 97 },
    daily_pu: { r: 40, g: 164, b: 189 },
    paid_rate: { r: 40, g: 164, b: 189 },
    total_ltv_0: { r: 47, g: 191, b: 155 },
    total_ltv_1: { r: 47, g: 191, b: 155 },
    total_ltv_3: { r: 47, g: 191, b: 155 },
    total_ltv_7: { r: 47, g: 191, b: 155 },
    total_ltv_14: { r: 47, g: 191, b: 155 },
    total_ltv_30: { r: 47, g: 191, b: 155 },
    total_ltv_45: { r: 47, g: 191, b: 155 },
    total_ltv_60: { r: 47, g: 191, b: 155 },
    ltv_iaa_1: { r: 40, g: 189, b: 58 },
    ltv_iaa_3: { r: 40, g: 189, b: 58 },
    ltv_iaa_7: { r: 40, g: 189, b: 58 },
    ltv_iaa_14: { r: 40, g: 189, b: 58 },
    ltv_iaa_30: { r: 40, g: 189, b: 58 },
    ltv_iaa_45: { r: 40, g: 189, b: 58 },
    ltv_iaa_60: { r: 40, g: 189, b: 58 },
    ltv_iap_1: { r: 40, g: 189, b: 132 },
    ltv_iap_3: { r: 40, g: 189, b: 132 },
    ltv_iap_7: { r: 40, g: 189, b: 132 },
    ltv_iap_14: { r: 40, g: 189, b: 132 },
    ltv_iap_30: { r: 40, g: 189, b: 132 },
    ltv_iap_45: { r: 40, g: 189, b: 132 },
    ltv_iap_60: { r: 40, g: 189, b: 132 },
    ltv_roas_0: { r: 189, g: 40, b: 90 },
    ltv_roas_1: { r: 189, g: 40, b: 90 },
    ltv_roas_3: { r: 189, g: 40, b: 90 },
    ltv_roas_7: { r: 189, g: 40, b: 90 },
    ltv_roas_14: { r: 189, g: 40, b: 90 },
    ltv_roas_30: { r: 189, g: 40, b: 90 },
    ltv_roas_45: { r: 189, g: 40, b: 90 },
    ltv_roas_60: { r: 189, g: 40, b: 90 },
  };


  const renderGroup = (items = filteredData, level = 0, parentKey = "") => {
    return items.map((item, index) => {
      const key = `${parentKey}-${index}`;
      const isExpanded = expandedGroups[key];
      const marginLeft = `${level * 20}px`;
      const hasChildren = Array.isArray(item.children) && item.children.length > 0;

      return (
        <React.Fragment key={key}>
          <tr>
            <td
              className="sticky-col-left"
              onClick={() => hasChildren && toggleGroup(key)}
              colSpan="2"
              style={{ width: `${columnWidths.__group__ || 400}px`, position: "sticky", left: 0, zIndex: 5, background: "#fff" }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  {hasChildren ? (
                    <i
                      className={`fa-solid ${
                        isExpanded ? "fa-chevron-down" : "fa-chevron-right"
                      } toggle-icon2`}
                      style={{
                        marginRight: "10px",
                        fontSize: "10px",
                        marginLeft,
                      }}
                    ></i>
                  ) : (
                    <span style={{ marginLeft }}></span>
                  )}
                  {getGroupName(item)}
                </div>
                {getImage(item)}
              </div>
            </td>
            {getVisibleColumns().map((field) => {
              const value = getValueFromItem(item, field) ?? 0;
              const isTopLevel = level === 0;
              const useParentScale = hasChildren || isTopLevel;
              const globalMax = useParentScale ? (maxValues.parent && maxValues.parent[field]) : (maxValues.child && maxValues.child[field]);
              const globalMin = useParentScale ? (maxValues.parentMin && maxValues.parentMin[field]) : (maxValues.childMin && maxValues.childMin[field]);
              const positiveColor = POSITIVE_COLORS[field] || { r: 40, g: 120, b: 189 };
              return (
            <ColorCell
                  key={field}
                  value={value}
                  globalMaxValue={globalMax}
                  globalMinValue={globalMin}
                  formatConfig={METRIC_FORMATS[field]}
                  positiveColor={positiveColor}
                />
              );
            })}
          </tr>

          {isExpanded &&
            hasChildren &&
            renderGroup(item.children, level + 1, key)}
        </React.Fragment>
      );
    });
  };

  const filterData = () => {
    if (!originalData.length) {
      setFilteredData(originalData);
      return;
    }

    const filterItem = (item) => {
      return Object.entries(filters.conditions).every(([field, condition]) => {
        if (!condition) return true;

        const value = getValueFromItem(item, field);

        
        const op1 = condition.operator1;
        const op2 = condition.operator2;
        const isBlankOp1 = op1 === "blank" || op1 === "notBlank";
        const isBlankOp2 = op2 === "blank" || op2 === "notBlank";

        if (isBlankOp1 && !isBlankOp2) {
          return checkSingleCondition(value, op1, null);
        }
        if (!isBlankOp1 && isBlankOp2) {
          return checkSingleCondition(value, op2, null);
        }
        if (isBlankOp1 && isBlankOp2) {
          const c1 = checkSingleCondition(value, op1, null);
          const c2 = checkSingleCondition(value, op2, null);
          return condition.logic === "AND" ? c1 && c2 : c1 || c2;
        }

        const hasValue1 =
          condition.value1 !== undefined && condition.value1 !== "";
        const hasValue2 =
          condition.value2 !== undefined && condition.value2 !== "";

        if (!hasValue1 && !hasValue2) return true;

        if (hasValue1 && !hasValue2) {
          return checkSingleCondition(
            value,
            condition.operator1,
            condition.value1
          );
        }

        if (!hasValue1 && hasValue2) {
          return checkSingleCondition(
            value,
            condition.operator2,
            condition.value2
          );
        }

        const condition1Passed = checkSingleCondition(
          value,
          condition.operator1,
          condition.value1
        );
        const condition2Passed = checkSingleCondition(
          value,
          condition.operator2,
          condition.value2
        );

        return condition.logic === "AND"
          ? condition1Passed && condition2Passed
          : condition1Passed || condition2Passed;
      });
    };

    const filteredParentItems = originalData.filter((item) => filterItem(item));

    if (React.startTransition) {
      React.startTransition(() => {
        setFilteredData(filteredParentItems);
      });
    } else {
      setFilteredData(filteredParentItems);
    }
  };

  const checkSingleCondition = (value, operator, conditionValue) => {
    
    const isBlank =
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim() === "") ||
      Number(value) === 0;

    if (operator === "blank") {
      return isBlank;
    }
    if (operator === "notBlank") {
      return !isBlank;
    }

    if (value === null || value === undefined) return false;

    if (Array.isArray(conditionValue)) {
      const from = parseFloat(conditionValue[0]);
      const to = parseFloat(conditionValue[1]);

      const numValue = isNumeric(value) ? parseFloat(value) : value;

      if (isNaN(from) && isNaN(to)) return true;

      if (!isNaN(from) && isNaN(to)) {
        return numValue >= from;
      }

      if (isNaN(from) && !isNaN(to)) {
        return numValue <= to;
      }

      if (!isNaN(from) && !isNaN(to)) {
        return numValue >= from && numValue <= to;
      }
    } else {
      const numValue = isNumeric(value) ? parseFloat(value) : value;
      const numCondition = isNumeric(conditionValue)
        ? parseFloat(conditionValue)
        : conditionValue;

      switch (operator) {
        case "equals":
          return numValue === numCondition;
        case "notEqual":
          return numValue !== numCondition;
        case "greatThan":
          return numValue > numCondition;
        case "greatThanOrEqual":
          return numValue >= numCondition;
        case "lessThan":
          return numValue < numCondition;
        case "lessThanOrEqual":
          return numValue <= numCondition;
        case "blank":
          
          return (
            value === null ||
            value === undefined ||
            (typeof value === "string" && value.trim() === "") ||
            Number(value) === 0
          );
        case "notBlank":
          
          return !(
            value === null ||
            value === undefined ||
            (typeof value === "string" && value.trim() === "") ||
            Number(value) === 0
          );
        default:
          return true;
      }
    }
  };

  const getValueFromItem = (item, field) => {
    let value;
    if (item.totals && item.totals[field] !== undefined) {
      value = item.totals[field];
    } else {
      value = item[field];
    }
    if (isNumeric(value)) {
      return parseFloat(parseFloat(value).toFixed(2));
    }

    return value;
  };

  useEffect(() => {
    
    filterData();
  }, [filters.conditions, originalData]);

  const getFieldLabel = (field) => {
    const fieldMap = {
      cost: "Cost",
      install_ad_network: "Ad Network Installs",
      install_attributed: "Attributed Installs",
      ecpi_ad_network: "Ad Network eCPI",
      ecpi_attributed: "Attributed eCPI",
      RR_D1: "RR D1",
      RR_D3: "RR D3",
      RR_D7: "RR D7",
      RR_D14: "RR D14",
      RR_D30: "RR D30",
      RR_D45: "RR D45",
      RR_D60: "RR D60",
      ad_revenue: "Ad Revenue",
      iap_revenue: "IAP Revenue",
      ipm: "IPM",
      ecpm: "eCPM",
      cti: "CTI",
      count_impression: "Impressions",
      count_session: "Session",
      count_clicks: "Clicks",
      ecpc: "eCPC",
      daily_pu: "Daily Paid Users",
      paid_rate: "Paid Rate",
      total_ltv_0: "LTV D0",
      total_ltv_1: "LTV D1",
      total_ltv_3: "LTV D3",
      total_ltv_7: "LTV D7",
      total_ltv_14: "LTV D14",
      total_ltv_30: "LTV D30",
      total_ltv_45: "LTV D45",
      total_ltv_60: "LTV D60",
      ltv_iaa_1: "Ad LTV D1",
      ltv_iaa_3: "Ad LTV D3",
      ltv_iaa_7: "Ad LTV D7",
      ltv_iaa_14: "Ad LTV D14",
      ltv_iaa_30: "Ad LTV D30",
      ltv_iaa_45: "Ad LTV D45",
      ltv_iaa_60: "Ad LTV D60",
      ltv_iap_1: "IAP LTV D1",
      ltv_iap_3: "IAP LTV D3",
      ltv_iap_7: "IAP LTV D7",
      ltv_iap_14: "IAP LTV D14",
      ltv_iap_30: "IAP LTV D30",
      ltv_iap_45: "IAP LTV D45",
      ltv_iap_60: "IAP LTV D60",
      ltv_roas_0: "ROAS D0",
      ltv_roas_1: "ROAS D1",
      ltv_roas_3: "ROAS D3",
      ltv_roas_7: "ROAS D7",
      ltv_roas_14: "ROAS D14",
      ltv_roas_30: "ROAS D30",
      ltv_roas_45: "ROAS D45",
      ltv_roas_60: "ROAS D60",
    };
    return fieldMap[field] || field;
  };

  const updateCondition = (field, key, value) => {
    setFilters((prev) => {
      const currentCondition = prev.conditions[field] || {
        operator1: "equals",
        value1: "",
        logic: "AND",
        operator2: "equals",
        value2: "",
      };

      if (key === "operator1" || key === "operator2") {
        if (
          (key === "operator1" &&
            currentCondition.operator1 === "between" &&
            value !== "between") ||
          (key === "operator2" &&
            currentCondition.operator2 === "between" &&
            value !== "between")
        ) {
          return {
            ...prev,
            conditions: {
              ...prev.conditions,
              [field]: {
                ...currentCondition,
                [key]: value,
                [key === "operator1" ? "value1" : "value2"]: "",
              },
            },
          };
        } else if (value === "between") {
          return {
            ...prev,
            conditions: {
              ...prev.conditions,
              [field]: {
                ...currentCondition,
                [key]: value,
                [key === "operator1" ? "value1" : "value2"]: ["", ""],
              },
            },
          };
        }
      }

      return {
        ...prev,
        conditions: {
          ...prev.conditions,
          [field]: {
            ...currentCondition,
            [key]: value,
          },
        },
      };
    });
  };

  const toggleFieldExpand = (field) => {
    setFilters((prev) => ({
      ...prev,
      activeField: prev.activeField === field ? null : field,
      expandedFields: {
        ...prev.expandedFields,
        [field]: !prev.expandedFields[field],
      },
    }));
  };

  const hasActiveFilter = (field) => {
    const condition = filters.conditions[field];
    if (!condition) return false;

    const hasValue1 = condition.value1 !== undefined && condition.value1 !== "";
    const hasValue2 = condition.value2 !== undefined && condition.value2 !== "";

    if (condition.operator1 === "between" && Array.isArray(condition.value1)) {
      return condition.value1.some((val) => val !== undefined && val !== "");
    }

    if (condition.operator2 === "between" && Array.isArray(condition.value2)) {
      return condition.value2.some((val) => val !== undefined && val !== "");
    }

    return hasValue1 || hasValue2;
  };

  const handleColumnFilterClick = (field, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setColumnFilterPopup({
      activeColumn: field,
      position: {
        top: rect.bottom,
        left: rect.left,
      },
    });

    setShowFilterPanel(false);
  };

  const isNumeric = (value) => {
    if (value === null || value === undefined || value === "") return false;
    return !isNaN(parseFloat(value)) && isFinite(value);
  };

  const [columnOrder, setColumnOrder] = useState([
    "cost",
    "install_ad_network",
    "install_attributed",
    "ecpi_ad_network",
    "ecpi_attributed",
    "RR_D1",
    "RR_D3",
    "RR_D7",
    "RR_D14",
    "RR_D30",
    "RR_D45",
    "RR_D60",
    "ad_revenue",
    "iap_revenue",
    "ipm",
    "ecpm",
    "cti",
    "count_impression",
    "count_session",
    "count_clicks",
    "ecpc",
    "daily_pu",
    "paid_rate",
    "total_ltv_0",
    "total_ltv_1",
    "total_ltv_3",
    "total_ltv_7",
    "total_ltv_14",
    "total_ltv_30",
    "total_ltv_45",
    "total_ltv_60",
    "ltv_iaa_1",
    "ltv_iaa_3",
    "ltv_iaa_7",
    "ltv_iaa_14",
    "ltv_iaa_30",
    "ltv_iaa_45",
    "ltv_iaa_60",
    "ltv_iap_1",
    "ltv_iap_3",
    "ltv_iap_7",
    "ltv_iap_14",
    "ltv_iap_30",
    "ltv_iap_45",
    "ltv_iap_60",
    "ltv_roas_0",
    "ltv_roas_1",
    "ltv_roas_3",
    "ltv_roas_7",
    "ltv_roas_14",
    "ltv_roas_30",
    "ltv_roas_45",
    "ltv_roas_60",
  ]);

  const [visibleColumns, setVisibleColumns] = useState({});

  const [columnWidths, setColumnWidths] = useState({ __group__: 400 });
  const [savedColumnsSnapshot, setSavedColumnsSnapshot] = useState(null);
  const storageKey = 'campaign-center-settings';

  useEffect(() => {
    try {
      const raw = localStorage.getItem(storageKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed.fields)) setFields(parsed.fields);
        if (parsed.rowGroupSortDirections && typeof parsed.rowGroupSortDirections === 'object') setRowGroupSortDirections(parsed.rowGroupSortDirections);
        if (Array.isArray(parsed.columnOrder)) setColumnOrder(parsed.columnOrder);
        if (parsed.visibleColumns && typeof parsed.visibleColumns === 'object') setVisibleColumns(parsed.visibleColumns);
        if (parsed.columnWidths && typeof parsed.columnWidths === 'object') setColumnWidths(parsed.columnWidths);
        setSavedColumnsSnapshot({
          columnOrder: parsed.columnOrder,
          visibleColumns: parsed.visibleColumns,
          columnWidths: parsed.columnWidths,
        });
      }
    } catch (_) {}
    finally {
      setSettingsLoaded(true);
    }
  }, [storageKey]);

  useEffect(() => {
    if (!savedColumnsSnapshot) {
      setSavedColumnsSnapshot({ columnOrder, visibleColumns, columnWidths });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnOrder, visibleColumns, columnWidths]);

  const hasPendingColumnChanges = React.useMemo(() => {
    if (!savedColumnsSnapshot) return false;
    try {
      const a = JSON.stringify({ columnOrder, visibleColumns, columnWidths });
      const b = JSON.stringify(savedColumnsSnapshot);
      return a !== b;
    } catch (_) {
      return false;
    }
  }, [columnOrder, visibleColumns, columnWidths, savedColumnsSnapshot]);

  const handleSaveSettings = React.useCallback(() => {
    try {
      const payload = {
        fields,
        rowGroupSortDirections,
        columnOrder,
        visibleColumns,
        columnWidths,
      };
      localStorage.setItem(storageKey, JSON.stringify(payload));
      setSavedColumnsSnapshot({ columnOrder, visibleColumns, columnWidths });
      if (toast) toast.success('Save config column success');
    } catch (e) {
      if (toast) toast.error('Save config column failed');
    }
  }, [fields, rowGroupSortDirections, columnOrder, visibleColumns, columnWidths, storageKey]);


  useEffect(() => {
    setColumnWidths((prev) => {
      const next = { ...prev };
      if (next.__group__ === undefined) next.__group__ = 400;
      columnOrder.forEach((f) => {
        if (next[f] === undefined) next[f] = 170;
      });
      return next;
    });
  }, [columnOrder]);

  useEffect(() => {
    
    setVisibleColumns((prev) => {
      const next = { ...prev };
      columnOrder.forEach((f) => {
        if (next[f] === undefined) next[f] = true;
      });
      return next;
    });
  }, [columnOrder]);

  const toggleColumnVisibility = (field) => {
    setVisibleColumns((prev) => ({ ...prev, [field]: !(prev[field] !== false) }));
  };

  const getVisibleColumns = () => columnOrder.filter((f) => visibleColumns[f] !== false);

  const setAllColumnsVisible = (checked) => {
    setVisibleColumns((prev) => {
      const next = { ...prev };
      columnOrder.forEach((f) => {
        next[f] = !!checked;
      });
      return next;
    });
  };

  const moveColumn = (from, to) => {
    
    let fromIndex = typeof from === "string" ? columnOrder.indexOf(from) : from;
    let toIndex = typeof to === "string" ? columnOrder.indexOf(to) : to;
    if (fromIndex < 0 || toIndex < 0) return;
    const newOrder = [...columnOrder];
    const [movedItem] = newOrder.splice(fromIndex, 1);
    newOrder.splice(toIndex, 0, movedItem);
    setColumnOrder(newOrder);
  };

  const ColumnField = ({ field, index, moveColumn }) => {
  const ref = React.useRef(null);
  
  const [, drop] = useDrop({
    accept: "COLUMN",
    hover(item) {
      if (!ref.current) return;
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) return;
      moveColumn(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging: isColumnDragging }, drag] = useDrag({
    type: "COLUMN",
    item: { type: "COLUMN", index, id: field },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <div
      ref={ref}
      style={{
        opacity: isColumnDragging ? 0.5 : 1,
        padding: "8px",
        background: "#f9f9f9",
        marginBottom: "4px",
        cursor: "move",
        display: "flex",
        alignItems: "center",
      }}
      className="d-flex align-items-center"
    >
      <div className="d-flex align-items-center">
        <div>
          <input
            type="checkbox"
            className="form-check-input me-2"
            checked={visibleColumns[field] !== false}
            onChange={() => toggleColumnVisibility(field)}
            onClick={(e) => e.stopPropagation()}
            style={{ position : 'initial' , marginTop : '0.3rem' , marginLeft : 0 }}
          />
        </div>
        <div className="me-2 icon-move">
          <CIcon
            icon={icon.cilMove}
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        </div>
        <div className="flex-fill">
          {getFieldLabel(field)}
        </div>
      </div>
    </div>
  );
};

  return (
    <>
      <div className="background-second-dashboard">
        <section className="main__content-dashbard">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <div className="tab-content" id="nav-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div className="detail-body">
                      <div className="overview_content pd-20">
                        <div className="mt-4">
                          <Spin spinning={loading} size="large">
                            <div>
                          {/* Mobile: Button to open filter drawer */}
                          <div className="mobile-search-toggle" style={{ 
                            display: 'none',
                            position: 'fixed',
                            bottom: '20px',
                            right: '20px',
                            zIndex: 1000
                          }}>
            <Button
              type="primary"
              shape="circle"
              icon={<SearchOutlined />}
              onClick={() => setDrawerOpen(true)}
              style={{
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                position: 'relative'
              }}
            />
          </div>

                          {/* Desktop: Show filters normally */}
                          <div className="desktop-filter">
                            <FilterCampaignCenter
                              startDate={startDateTab1}
                              endDate={endDateTab1}
                              handleChangeDate={(e, picker) => {
                                setStartDateTab1(picker.startDate);
                                setEndDateTab1(picker.endDate);
                              }}
                              id="filter-tab1"
                              onRunReport={(filters) => {
                                handleRunReportTab1(filters);
                                // Close drawer on mobile
                                setDrawerOpen(false);
                              }}
                            />
                          </div>
                          <TableContainer
                            fields={fields}
                            getVisibleColumns={getVisibleColumns}
                            sortConfig={sortConfig}
                            toggleSort={toggleSort}
                            getFieldLabel={getFieldLabel}
                            hasActiveFilter={hasActiveFilter}
                            handleColumnFilterClick={handleColumnFilterClick}
                            sortedData={sortedData}
                            renderGroup={renderGroup}
                            dataTotal={dataTotal}
                            formatNumber={formatNumber}
                            METRIC_FORMATS={METRIC_FORMATS}
                            columnFilterPopup={columnFilterPopup}
                            columnPopupRef={columnPopupRef}
                            ColumnFilterPopupContent={ColumnFilterPopupContent}
                            filters={filters}
                            updateCondition={updateCondition}
                            onCloseColumnFilterPopup={() => setColumnFilterPopup({ activeColumn: null, position: { top: 0, left: 0 } })}
                            showPopup={showPopup}
                            togglePopup={togglePopup}
                            onSaveSettings={handleSaveSettings}
                            hasPendingColumnChanges={hasPendingColumnChanges}
                            rowGroupSortDirections={rowGroupSortDirections}
                            onRowGroupSortChange={handleRowGroupSortChange}
                            fieldsPanel={{ FilterField, moveField, toggleCheck }}
                            applyRowGroupChanges={applyRowGroupChanges}
                            hasPendingRowGroupChanges={hasPendingRowGroupChanges}
                            showFilterPanel={showFilterPanel}
                            setShowFilterPanel={setShowFilterPanel}
                            columnsPanel={{ searchTerm, setSearchTerm, columnOrder, setAllColumnsVisible, ColumnField }}
                            headerDrag={{ moveColumn }}
                            columnWidths={columnWidths}
                            setColumnWidth={(field, width) => setColumnWidths((prev) => ({ ...prev, [field]: Math.max(80, Math.min(600, Math.round(width))) }))}
                            setFilters={setFilters}
                            filterableColumns={filterableColumns}
                            toggleFieldExpand={toggleFieldExpand}
                            renderFilterFieldControls={renderFilterFieldControls}
                                />
                            </div>
                          </Spin>
                      </div>
                    </div>
                    <PaginationComponent
                      current={currentPage}
                      total={totalPage}
                      handleChangePage={handleChangePage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </section>
      </div>

      {/* Mobile: Drawer with filters */}
      <Drawer
        title="Search Filters"
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={320}
        className="mobile-filter-drawer"
        zIndex={2500}
      >
        <FilterCampaignCenter
          startDate={startDateTab1}
          endDate={endDateTab1}
          handleChangeDate={(e, picker) => {
            setStartDateTab1(picker.startDate);
            setEndDateTab1(picker.endDate);
          }}
          id="filter-tab1-drawer"
          onRunReport={(filters) => {
            handleRunReportTab1(filters);
            // Close drawer on mobile
            setDrawerOpen(false);
          }}
        />
      </Drawer>

      <style>{`
        /* Mobile styles */
        @media (max-width: 768px) {
          .desktop-filter {
            display: none !important;
          }
          .mobile-search-toggle {
            display: block !important;
          }
          /* Drawer body padding on mobile */
          .mobile-filter-drawer .ant-drawer-body { padding: 10px !important; }
          /* Ensure date dropdown in Drawer doesn't overflow width */
          .mobile-filter-drawer .drawer-date-dropdown {
            max-width: 100% !important;
          }
          .mobile-filter-drawer .drawer-date-dropdown .ant-picker-panels {
            flex-direction: column !important;
          }
        }
        @media (min-width: 769px) {
          .mobile-search-toggle {
            display: none !important;
          }
          .desktop-filter {
            display: block !important;
          }
        }
      `}</style>
    </>
  );
}
export default AppCampaignCenter;
